import { render, staticRenderFns } from "./ChildUser.vue?vue&type=template&id=ce2ad5d6&scoped=true"
import script from "./ChildUser.vue?vue&type=script&lang=js"
export * from "./ChildUser.vue?vue&type=script&lang=js"
import style0 from "./ChildUser.vue?vue&type=style&index=0&id=ce2ad5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ad5d6",
  null
  
)

export default component.exports